import { Crisp } from 'crisp-sdk-web';

function crispChatInit() {
  if (typeof window !== 'undefined') {
    Crisp.configure("3acb4f5f-e3ef-406e-a41d-f8d8b9b11c84");
  }
}

export default crispChatInit;